import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import {API} from 'aws-amplify';
import './instanceTerraform.css';

const InstanceTerraform = (props) => {

  const [sInstanceTerra, uInstanceTerra] = useState('');
  const [sAccounts, uAccounts] = useState([]);
  const [sAccount, uAccount] = useState('');
  const [sInstances, uInstances] = useState([]);
  const [sInstanceInput, uIntstanceInput] = useState('');

  useEffect(() => {
    API.get('WBU', '/accounts', {})
    .then(res => {
      const accounts = JSON.parse(res.body).sort((a, b) => {
        return [a.Name, b.Name].sort()[0] === a.Name ? -1 : 1;
      });
      console.log(accounts);
      uAccounts(accounts);
    })
    .catch(err => {
      console.log(err);
    });
  }, []);

  useEffect(() => {
    if (sAccount) {
      uInstanceTerra('Loading Instances...');
      API.get('WBU', '/instances', {
        queryStringParameters: {
          accountId: sAccount
        }
      })
      .then(res => {
        console.log(res);
        document.getElementById('instances-search').select();
        document.getElementById('instances-search').select();
        uInstances(res);
      })
      .catch(err => {
        console.log(err);
      });
    }
  }, [sAccount]);

  useEffect(() => {
    uInstanceTerra('Instances Loaded');
  }, [sInstances]);

  // useEffect(() => {
  //   API.get('WBU', '/instanceterraform', {
  //     queryStringParameters: {
  //       instanceId: 'i-044f7191d915bb51c',
  //       accountId: sAccount
  //     }
  //   })
  //   .then(res => {
  //     uInstanceTerra(res);
  //   })
  //   .catch(err => {
  //     console.log(err);
  //   });
  // }, []);

  const loadTerraformFile = () => {

    let instanceId = sInstanceInput.match(/- (.+?) -/) && sInstanceInput.match(/- (.+?) -/)[1];

    if (!instanceId) {
      if (sInstances.find(instance => instance.InstanceId === sInstanceInput)) {
        instanceId = sInstances.find(instance => {
          return instance.InstanceId === sInstanceInput;
        }).InstanceId;
      }
      if (sInstances.find(instance => instance.Name === sInstanceInput)) {
        instanceId = sInstances.find(instance => {
          return instance.Name === sInstanceInput;
        }).InstanceId;
      }
    }

    console.log(instanceId);

    if (instanceId) {
      uInstanceTerra('Fetching Terraform Document...');
      API.get('WBU', '/instanceterraform', {
        queryStringParameters: {
          instanceId,
          accountId: sAccount
        }
      })
      .then(res => {
        uInstanceTerra(res);
      })
      .catch(err => {
        console.log(err);
      });
    } else {
      uInstanceTerra('Instance Not Found');
    }

  };

  const copyText = () => {
    const text = document.createElement('textarea');
    text.value = sInstanceTerra;
    document.body.appendChild(text);
    text.select();
    document.execCommand('copy');
    document.body.removeChild(text);
  };

  const handleEnterPress = e => {
    if (e.keyCode === 13) loadTerraformFile();
  };

  return (
    <div className="InstanceTerraformPage">
      <select onChange={e => uAccount(e.target.value)} value={sAccount}>
        {sAccounts.map(account => {
          return <option value={account.Id} key={account.Id}>{account.Name}</option>;
        })}
      </select>
      <input id="instances-search"
        list="instances"
        name="instance"
        value={sInstanceInput}
        onChange={e => uIntstanceInput(e.target.value)}
        onKeyDown={handleEnterPress}
        placeholder="Search..."
      />
      <datalist id="instances">
        {sInstances.map(instance => {
          const nameTag = instance.Tags.find(tag => tag.Key === 'Name');
          const name = nameTag ? nameTag.Value : 'No Name Tag';
          const clientTag = instance.Tags.find(tag => tag.Key === 'Client');
          const client = clientTag ? clientTag.Value : 'No Client Tag';
          return <option key={`option-${instance.InstanceId}`} value={`${name} - ${instance.InstanceId} - ${client}`}></option>;
        })}
      </datalist>
      <button onClick={loadTerraformFile}>LOAD TERRAFORM FILE</button>
      <button onClick={copyText}>COPY TO CLIPBOARD</button>
      <br/>
      <textarea rows="45" cols="120" value={sInstanceTerra}></textarea>
    </div>
  );

};

InstanceTerraform.propTypes = {

};

export default InstanceTerraform;


// WEBPACK FOOTER //
// ./src/components/content/instanceTerraform/instanceTerraform.js